import { AxiosInstance, AxiosPromise } from 'axios';
import { Attachment } from '../../../../types/Attachment';
import {
  GetAttachmentParams,
  AttachmentEndpoint,
  UploadAttachmentBody,
  UploadAttachmentParams,
} from './AttachmentServices.types';

export class AttachmentServices implements AttachmentEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(params: GetAttachmentParams): AxiosPromise<Attachment[]> {
    return this.instance.get('/attachments/search', {
      params: {
        parent: params.parent,
        parentType: params.parentType,
        attachmentType: params?.attachmentType,
        visbility: params?.visibility,
      },
    });
  }

  upload(params: UploadAttachmentParams, body: UploadAttachmentBody): AxiosPromise<Attachment[]> {
    return this.instance.post('/attachments', body, {
      params: {
        parent: params.parent,
        parentType: params.parentType,
        attachmentType: params.attachmentType,
        visibility: params.visibility,
      },
    });
  }

  async delete(guid: string) {
    return this.instance.delete(`/attachments/${guid}`);
  }
}
